import { SEARCH_APPEARS_ON_FILTER_FIELD } from '@disco/constants/search'

import type { FilterDefinition } from 'types/filter-page'

// Shared by the filter bar and the in-table controls editing the same `filters`
// entry. Apart from ./config, which wires up the filter form components.

export const APPEARS_ON_FILTER_DEFINITION: FilterDefinition = {
  label: 'Appears on',
  type: 'number',
  field: SEARCH_APPEARS_ON_FILTER_FIELD,
  isNew: true,
}

// Defined in utils so the tag-click flows build the same entry; re-exported
// here to keep it alongside its siblings.
export { TAGS_FILTER_DEFINITION } from '@disco/utils/search-page'
